import { gql } from '@apollo/client';

export const READ_FLYER_MUTATION = gql`
  mutation readFlyer($input: ReadFlyerInput!) {
    readFlyer(input: $input) {
      flyerId
      isRead
    }
  }
`;
